const notificationSound = require('./notification.mp3');

export { notificationSound };
